import numeral from 'numeral';

// ----------------------------------------------------------------------

// Guard against Italian comma-decimals stored as strings (e.g. "27,5"):
// numeral() would read the comma as a thousands separator and turn "27,5"
// into 275. Only a value that is unambiguously a decimal comma (no dot, a
// single comma followed by 1-2 digits) is normalized, so genuine
// thousands-separated strings like "1,234" are left untouched.
function normalizeDecimalComma(number) {
  if (typeof number === 'string' && /^-?\d+,\d{1,2}$/.test(number.trim())) {
    return number.trim().replace(',', '.');
  }
  return number;
}

// export function fCurrency(number) {
//   return numeral(number).format(Number.isInteger(number) ? '€0,0' : '€0,0.00');
// }
export function fCurrency(number) {
  const formattedValue = numeral(normalizeDecimalComma(number)).format('0,0.00');
  return `€${formattedValue}`;
}
export function fCurrencyByType(number, type) {
  const formattedValue = numeral(normalizeDecimalComma(number)).format('0,0.00');
  let symbol =
    type === 'EUR' ? '€' : type === 'USD' ? '$' : type === 'GBP' ? '£' : '€';
  return `${symbol}${formattedValue}`;
}
export function fNegativeCurrencyByType(number, type) {
  const formattedValue = numeral(normalizeDecimalComma(number)).format('0,0.00');
  let symbol =
    type === 'EUR' ? '€' : type === 'USD' ? '$' : type === 'GBP' ? '£' : '€';
  return `${symbol}-${formattedValue}`;
}
export function fCurrencyDecimal(number) {
  const num = parseFloat(number) || 0;
  let s = num.toFixed(4);
  // Remove trailing zeros but keep at least 2 decimal places
  while (s.slice(-1) === '0' && s.length - s.indexOf('.') > 3) {
    s = s.slice(0, -1);
  }
  return `€${s}`;
}
export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fShortenCurrency(number) {
  const formattedValue = numeral(number).format('0.00a').replace('.00', '');
  return `€${formattedValue}`;
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}
